import {Box, CircularProgress, Typography} from "@mui/material";

export const LoadingScreen = () => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      background:
        "linear-gradient(165deg, #f8fafc 0%, #e2e8f0 45%, #ccfbf1 100%)",
    }}
  >
    <CircularProgress size={44} thickness={4} sx={{color: "primary.main"}} />
    <Typography variant="body2" color="text.secondary" sx={{fontWeight: 500}}>
      Carregando aplicação…
    </Typography>
  </Box>
);
